import Navigation from "@/components/Navigation";
import Footer from "@/components/Footer";
import { Heart, Users, Leaf } from "lucide-react";

export default function QuiSommesNous() {
  return (
    <div className="min-h-screen flex flex-col bg-gradient-to-b from-background to-soft">
      <Navigation />
      
      <main className="flex-1">
        {/* Hero Section */}
        <section className="py-12 lg:py-16 bg-gradient-primary mt-10">
          <div className="container mx-auto px-4 lg:px-8">
            <div className="max-w-3xl mx-auto text-center">
              <h1 className="font-display text-4xl lg:text-5xl font-bold text-gradient mb-4">
                Qui sommes-nous ?
              </h1>
              <p className="text-lg text-foreground">
                Découvrez l'histoire et les valeurs de WeMemberz
              </p>
            </div>
          </div>
        </section>

        {/* Content Sections */}
        <section className="">
          <div className="container mx-auto px-4 lg:px-8">
            <div className="max-w-4xl mx-auto space-y-20">
              
              {/* Notre Histoire */}
              <div className="space-y-6">
                <div className="flex items-center gap-3 mb-6">
                  <Heart className="w-8 h-8 text-primary" />
                  <h2 className="font-display text-2xl lg:text-3xl font-bold text-foreground">
                    Notre histoire
                  </h2>
                </div>
                
                <div className="space-y-4 text-muted-foreground leading-relaxed">
                  <p>
                    L'histoire de WeMemberz est simple. Une équipe d'épicuriens s'est réunie pour faciliter la création d'album photo en ligne. Ce qui leur tient à cœur ? Ancrer leurs meilleurs souvenirs en famille, entre amis, en amoureux…
                  </p>
                  
                  <p>
                    La création d'album photo est souvent fastidieuse : récolte des photos, tri, choix de la plateforme de création, édition… L'équipe WeMemberz constate que ce n'est jamais réellement un jeu d'enfant de créer un album photo et ce, pour les divers événements de l'année : voyages, anniversaires, fêtes en famille, mariages…
                  </p>
                  
                  <p>
                    Nous avons eu l'idée, mais surtout le besoin, de simplifier la création d'album photo en réunissant les souvenirs photos numériques dans une conversation de groupe. Toutes les personnes de la conversation peuvent ainsi ajouter leur touche personnelle et créer un souvenir papier inoubliable ! Réaliser un album photo ensemble est désormais à la portée de tous, grâce à notre concept innovant…
                  </p>
                </div>
              </div>

              {/* Notre Concept */}
              <div className="space-y-6">
                <div className="flex items-center gap-3 mb-6">
                  <Users className="w-8 h-8 text-primary" />
                  <h2 className="font-display text-2xl lg:text-3xl font-bold text-foreground">
                    Notre concept innovant
                  </h2>
                </div>
                
                <div className="space-y-4 text-muted-foreground leading-relaxed">
                  <p>
                    Notre application est le moyen le plus facile pour échanger des photos avec vos proches et enfin créer votre album photo, ensemble ! L'application vous permet de créer des groupes de discussion. Ainsi, vous pouvez discuter, partager vos meilleurs souvenirs photos au fil du temps.
                  </p>
                  
                  <p>
                    Le coup de maître ? Vos photos sont synchronisées sur l'éditeur en ligne de notre site, de manière automatique ! L'administrateur du groupe peut accéder à l'éditeur en ligne avec tout le contenu posté par vos proches. Cela lui facilite grandement la création de votre album photo, tout en ayant le point de vue de chacun.
                  </p>
                  
                  <p>
                    Avec l'application WeMemberz, fini les photos éparpillées, perdues, effacées par le temps ! Gardez vos meilleurs souvenirs sous la main, dans votre conversation entre amis, en famille, en amoureux… directement prêts à devenir un réel objet de valeur, format papier.
                  </p>
                </div>
              </div>

              {/* Nos Valeurs */}
              <div className="space-y-6">
                <div className="flex items-center gap-3 mb-6">
                  <Leaf className="w-8 h-8 text-primary" />
                  <h2 className="font-display text-2xl lg:text-3xl font-bold text-foreground">
                    Nos valeurs et engagements
                  </h2>
                </div>
                
                <div className="space-y-4 text-muted-foreground leading-relaxed">
                  <p>
                    WeMemberz est née de la passion du partage ! L'équipe souhaite transmettre ses valeurs familiales à travers l'élaboration d'une plateforme collaborative, intuitive, accessible à tous. L'application WeMemberz se veut intéractive afin de réunir des proches de façon intergénérationnelle, autour d'un même album photo personnalisé.
                  </p>
                  
                  <p>
                    L'équipe s'engage à vous écouter et respecter toutes vos envies de création afin de proposer le meilleur service de l'album photo en ligne.
                  </p>
                  
                  <p>
                    WeMemberz s'engage aussi pour la planète ! Les albums photos sont imprimés de façon responsable. Nos imprimeurs possèdent les labels PEFC et FSC, certifiant une gestion forestière écologiquement appropriée, socialement bénéfique et économiquement viable.
                  </p>
                  
                  <p>
                    Le label Imprim'vert est également de mise. Il permet de réduire évidemment l'impact de l'impression sur la planète, en faisant des choix stratégiques, écologiques et surtout made in France !
                  </p>
                </div>
              </div>

            </div>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
}
